<template>
	<div class="print-container">
		<auth-container :page="$parent.page">
			<print-menu></print-menu>

			<div class="d-flex mb-4">
				<h2 class="mr-2">Flood Control Structural Repair Program<br />Reimbursement Submission #{{$parent.item.submissionNumber}}</h2>
				<div class="ml-auto text-right">
					<img :src="`${publicPath}images/logos/tsswcb-logo.svg`" alt="TSSWCB Logo" class="img-fluid" style="width:170px">
				</div>
			</div>

			<b-row>
				<b-col md>
					<b-table-simple small class="table-definitions">
						<b-tbody>
							<b-tr>
								<b-th>Submission #</b-th>
								<b-td>{{valueOrNa($parent.item.submissionNumber)}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Submission Date</b-th>
								<b-td>{{$parent.item.submissionDate | date('ddd, MMM D, YYYY', 'N/A')}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Agency Staff</b-th>
								<b-td>{{valueOrNa($parent.item.agencyStaff)}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Department</b-th>
								<b-td>{{valueOrNa($parent.item.department)}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Approval Notice Date</b-th>
								<b-td>{{$parent.item.approvalNoticeDate | date('ddd, MMM D, YYYY', 'N/A')}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Funds Arrival Date</b-th>
								<b-td>{{$parent.item.fundsArrivalDate | date('ddd, MMM D, YYYY', 'N/A')}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Funds Left Date</b-th>
								<b-td>{{$parent.item.fundsLeftDate | date('ddd, MMM D, YYYY', 'N/A')}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Submission Category</b-th>
								<b-td>{{valueOrNa($parent.item.submissionCategory, 'None')}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Notes</b-th>
								<b-td>{{valueOrNa($parent.item.notes, 'None')}}</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-col>
			</b-row>
		</auth-container>
	</div>
</template>

<script>
	import PrintMenu from '@/components/helpers/PrintMenu';

	export default {
		name: 'SrReimbursementPrint',
		components: { PrintMenu }
	}
</script>